<template>
  <div class="container-fluid">
    <div class="contents event">
      <b-form @submit="onSubmit">
        <div class="row row-cols-2 row-cols-xl-5 g-2 mb-4">
          <div class="col-xl-2">
            <input
              type="date"
              name="startdate"
              class="form-control-lg"
              v-model="searchData.startdate"
            />
          </div>
          <div class="col-xl-2">
            <input
              type="date"
              name="enddate"
              class="form-control-lg"
              v-model="searchData.enddate"
            />
          </div>
          <div class="col-xl-2">
            <select
              aria-label="Select Mini Game Type"
              name="type"
              v-model="searchData.status_cd"
            >
              <option value="-1">{{ $t("filter.common.total") }}</option>
              <option value="0">{{ $t("text.common.ready") }}</option>
              <option value="1">{{ $t("text.common.playing") }}</option>
              <option value="2">{{ $t("text.common.completed") }}</option>
            </select>
          </div>
          <div class="col-xl-2">
            <select
              aria-label="Select minigame type"
              name="type"
              v-model="searchData.type"
            >
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="1">{{ $t("filter.event.holeinone") }}</option>
              <option value="2">{{ $t("filter.event.albatross") }}</option>
              <option value="3">{{ $t("filter.event.eagle_p5") }}</option>
              <option value="4">{{ $t("filter.event.birdie_p5") }}</option>
              <option value="5">{{ $t("filter.event.par_p5") }}</option>
              <option value="6">{{ $t("filter.event.eagle_p4") }}</option>
              <option value="7">{{ $t("filter.event.birdie_p4") }}</option>
              <option value="8">{{ $t("filter.event.par_p4") }}</option>
              <option value="9">{{ $t("filter.event.longest") }}</option>
              <option value="10">{{ $t("filter.event.nearpin") }}</option>
              <option value="11">{{ $t("filter.event.longestrank") }}</option>
              <option value="12">{{ $t("filter.event.nearpinrank") }}</option>
            </select>
          </div>
          <div class="col-xl-2">
            <select
              aria-label="Select one"
              name="searchtype"
              v-model="searchData.searchtype"
            >
              <option value="1">{{ $t("filter.common.title") }}</option>
              <option value="2">{{ $t("filter.common.course") }}</option>
            </select>
          </div>
          <div class="col-xl-2">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder=""
                name="searchname"
                v-model="searchData.searchname"
              />
              <button
                class="btn btn-primary btn-lg icon-search"
                type="submit"
                value=""
              ></button>
            </div>
          </div>
        </div>
      </b-form>

      <div class="row g-0 table-type header-col p-keep">
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("title.event.holeinone") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.holeinone | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("title.event.albatross") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.albatross | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.eagle_p5") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.eaglep5 | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.birdie_p5") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.birdiep5 | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.par_p5") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.parp5 | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.eagle_p4") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.eaglep4 | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.birdie_p4") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.birdiep4 | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.par_p4") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.parp4 | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.longest") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.longest | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.nearpin") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">{{ eventtoplist.nearpin | comma }}</p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.longestrank") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">
            {{ eventtoplist.longestrank | comma }}
          </p>
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1">
          {{ $t("filter.event.nearpinrank") }}
        </div>
        <div class="col-6 col-sm-3 col-md-2 col-xxl-1 d-flex">
          <p class="align-self-center">
            {{ eventtoplist.nearpinrank | comma }}
          </p>
        </div>
      </div>

      <table class="table board toggle-xxl mt-4">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th> -->
            <th class="col-auto">
              {{ $t("title.common.title") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.type") }}
            </th> -->
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.event.prizes") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell text-nowrap">
              {{ $t("title.event.entrylimit") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell text-nowrap">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto text-nowrap w-1">
              {{ $t("title.event.leaderboard") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <!-- <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td> -->
              <td class="col-auto d-lg-table-cell text-start">
                <a
                  class="d-inline-block pointer"
                  @click="showModal(item.eventno)"
                >
                  <!-- <span class="badge minigame-type">
                    {{ item.awardtype | awardtype }}
                  </span> -->
                  <span class="badge minigame-event-type">
                    {{ event_type(item.type) }}
                  </span> 
                  <p class="minigame-title more">{{ item.title }}</p>
                </a>
              </td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                <!-- 서비스 시간 -->
                {{ item.timezone_startdate | dateformat }}
                ~
                {{ item.timezone_enddate | dateformat }}
              </td>
              <!-- <td class="col-auto d-none d-lg-table-cell">
                {{ event_type(item.type) }}
              </td> -->
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.coursename }} {{ item.subcoursename }}({{ item.hole }}H)
              </td>
              <td class="col-auto d-none d-xxl-table-cell text-prize">
                {{ item.type < 11 ? null || item.point : "Rank Prize" }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell text-red">
                {{ item.entrylimit | transToValue("∞") }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{ event_status(item.status) }}
              </td>
              <td class="col-auto w-1">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-xs w-75"
                  v-if="item.type > 10"
                  @click="
                    $router.push({
                      name: 'MiniGameRanking',
                      params: { eventno: item.eventno },
                    })
                  "
                >
                  {{ $t("button.common.ranking") }}
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-xs w-75"
                  v-else
                  @click="
                    $router.push({
                      name: 'WinAMiniGameList',
                      params: { eventno: item.eventno },
                    })
                  "
                >
                  {{ $t("button.common.view") }}
                </button>
              </td>
              <!-- <td class="col-auto d-none d-lg-table-cell">
                <button
                  class="btn btn-primary btn-xs"
                  type="button"
                  @click="
                    $router
                      .push({
                        name: 'MiniGameModify',
                        params: { eventno: item.eventno },
                      })
                      .catch(() => {})
                  "
                >
                  {{ $t("button.modify") }}
                </button>
              </td> -->
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <!--                   <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div> -->
                  <div class="row d-lg-none">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8 text-date">
                      <!-- 서비스 시간 -->

                      {{ item.timezone_startdate | dateformat }}
                      ~
                      {{ item.timezone_enddate | dateformat }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-4">{{ $t("title.common.type") }}</div>
                    <div class="col-8">{{ event_type(item.type) }}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.course") }}</div>
                    <div class="col-8">
                      {{ item.coursename }} {{ item.subcoursename }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.hole") }}</div>
                    <div class="col-8">{{ item.hole }}H</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.prizes") }}</div>
                    <div class="col-8 text-prize">
                      {{ item.type < 11 ? null || item.point : "Rank Prize" }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.event.entrylimit") }}</div>
                    <div class="col-8 text-red">
                      {{ item.entrylimit | transToValue("∞") }}
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.common.status") }}</div>
                    <div class="col-8">
                      {{ event_status(item.status) }}
                    </div>
                  </div>
                  <!--                   <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.event.leaderboard") }}</div>
                    <div class="col-8">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-xs"
                        v-if="item.type > 10"
                        @click="
                          $router.push({
                            name: 'MiniGameRanking',
                            params: { eventno: item.eventno },
                          })
                        "
                      >
                        {{ $t("button.common.ranking") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-xs"
                        v-else
                        @click="
                          $router.push({
                            name: 'WinAMiniGameList',
                            params: { eventno: item.eventno },
                          })
                        "
                      >
                        {{ $t("button.common.view") }}
                      </button>
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-4">Edit</div>
                    <div class="col-8">
                      <button
                        class="btn btn-primary btn-xs"
                        type="button"
                        @click="
                          $router
                            .push({
                              name: 'MiniGameModify',
                              params: { eventno: item.eventno },
                            })
                            .catch(() => {})
                        "
                      >
                        {{ $t("button.modify") }}
                      </button>
                    </div>
                  </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        aria-label="Page navigation example"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <a v-if="active">{{ page }}</a>
          <a v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>

      <!--       <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.event.mingame_winners')"
          @click="$router.push({ name: 'MiniGameWinningList' }).catch(() => {})"
          >{{ $t("button.event.mingame_winners") }}</b-button
        >
      </div> -->
    </div>
    <b-modal
      id="modal-minigame-info"
      ref="modal-minigame-info"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("menu.event.minigame_informaition") }}
        </h5>
        <b-button
          data-bs-dismiss="modal"
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        >
        </b-button>
      </template>

      <span class="badge minigame-event-type">
        <!-- {{ eventinfo.awardtype | awardtype }} /  -->
        {{ event_type(eventinfo.type) }}
      </span>
      <p class="modal-subtitle minigame-title">
        {{ eventinfo.title }}
      </p>

      <div class="row row-cols-1 row-cols-lg-auto gy-2 lh-sm">
        <div class="col text-date">
          <!-- 사용자 시간 -->
          {{ eventinfo.timezone_startdate | dateformat }} ~
          {{ eventinfo.timezone_enddate | dateformat }}
        </div>
      </div>

      <div class="row g-0 table-type header-col p-keep mt-3">
        <div class="col-sm-4">
          {{ $t("title.common.course") }}
        </div>
        <div class="col-sm-8">
          {{ eventinfo.coursename }} {{ eventinfo.description }}
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.hole") }}
        </div>
        <div class="col-sm-8">{{ eventinfo.hole }}H</div>

        <div class="col-sm-4">
          {{ $t("title.tournament.level") }}
        </div>
        <div class="col-sm-8">{{ event_level(eventinfo.level_fk) }}</div>

        <!-- <div class="col-sm-4">
          {{ $t("title.common.greenspeed") }}
        </div>
        <div class="col-sm-8">
          {{ eventinfo.greenspeed_fk | greenspeed }}
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.greengravity") || 'Green Gravity' }}
        </div>
        <div class="col-sm-8">
          {{ eventinfo.greengravity_fk | greengravity }}
        </div> -->

        <div class="col-sm-4">
          {{ $t("title.event.entrylimit") }}
        </div>
        <div class="col-sm-8 text-red">
          {{ eventinfo.entrylimit | transToValue("∞") }}
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.teebox") }}
        </div>
        <div class="col-sm-8">
          <div class="row row-cols-1 row-cols-lg-auto gy-2">
            <div class="col">
              {{ $t("text.common.male") }} :
              {{ eventinfo.teeboxman | teeboxType }}
            </div>
            <div class="col">
              {{ $t("text.common.female") }} :
              {{ eventinfo.teeboxwoman | teeboxType }}
            </div>
          </div>
        </div>

        <div
          class="col-sm-4"
          v-if="eventinfo.type == '9' || eventinfo.type == '10'"
        >
          {{ $t("title.common.distance") }}
        </div>
        <div
          class="col-sm-8"
          v-if="eventinfo.type == '9' || eventinfo.type == '10'"
        >
          {{
            eventinfo.distance != "0"
              ? eventinfo.distance
              : $t("text.common.unregistered")
          }}m
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.prizes") }}
        </div>
        <div class="col-sm-8 text-prize" v-if="eventinfo.type < 11">
          {{ eventinfo.point }}
        </div>
        <div class="col-sm-8" v-else>
          <div class="row row-cols-1 row-cols-lg-3 g-2 g-lg-3 flex-grow-1">
            <template v-for="(item, index) in awardprizeranklist">
              <div :key="'a' + index" class="col">
                <div class="card h-100">
                  <div class="card-body">
                    <h6 class="card-title fs-6">
                      {{ $t("title.common.top_rank") }}{{ item.rank_no }}
                    </h6>
                    <p class="card-text pt-1 lh-sm text-prize">
                      {{ item.prize }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <template v-if="eventinfo.standard_point != 0">
          <div class="col-sm-4">
            {{ $t("title.common.point_allocation") }}
          </div>
          <div class="col-sm-8 text-point-sp">
            {{ $t("title.common.standard_point") }}
          </div>
        </template>
      </div>

      <template #modal-footer="{}">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="hideModal"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/event";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MiniGameList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs(new Date().setMonth(new Date().getMonth() - 1)).format(
            "YYYY-MM-DD"
          ),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs(new Date()).format("YYYY-MM-DD"),
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "1",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        type:
          this.$route.query.type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].type) ||
          0,
        status_cd:
          this.$route.query.status_cd ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].status_cd) ||
          "1",
      },
      eventinfo: {},
      awardprizeranklist: [],
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
      eventtoplist: [],
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.get_ownereventlist();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.get_ownereventlist();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_ownereventlist();
    },
    "searchData.type": function () {
      this.searchData.pageno = 1;
      this.get_ownereventlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_ownereventlist();
    },

    "searchData.pageno": function () {
      this.get_ownereventlist();
    },
    "searchData.status_cd": function () {
      this.searchData.pageno = 1;
      this.get_ownereventlist();
    },
  },
  methods: {
    showModal(eventno) {
      // console.log(hole,type);
      ax.get_eventview(eventno, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.eventinfo = data.eventinfo;

          this.awardprizeranklist = data.awardprizerank;

          this.$refs["modal-minigame-info"].show();
        } else {
          alert(data.message);
        }
      });
    },
    hideModal() {
      this.$refs["modal-minigame-info"].hide();
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;

      this.get_ownereventlist();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    get_ownereventlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_ownereventlist(this.searchData, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          if (data.eventlistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.eventlistcnt;
          this.page_total = Math.ceil(data.eventlistcnt / this.rows);
          this.items = data.eventlist;
          this.eventtoplist = data.eventtoplist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_ownereventlist();
  },

  mixins: [myMixin],
};
</script>